module.exports = __webpack_public_path__ + "/login_ui/img/cm-81d87baa6dfb7d5709d77d78e5948f2d.svg";